import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Country pages
export const CountryListPage = lazy(
  () =>
    retry(() => import('@pages/settings/countries/list')) as Promise<
      typeof import('@pages/settings/countries/list')
    >
);

export const CountryEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/countries/edit')) as Promise<
      typeof import('@pages/settings/countries/edit')
    >
);

export const CountryCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/countries/create')) as Promise<
      typeof import('@pages/settings/countries/create')
    >
);

// Currency pages
export const CurrencyListPage = lazy(
  () =>
    retry(() => import('@pages/settings/currencies/list')) as Promise<
      typeof import('@pages/settings/currencies/list')
    >
);

export const CurrencyEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/currencies/edit')) as Promise<
      typeof import('@pages/settings/currencies/edit')
    >
);

export const CurrencyCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/currencies/create')) as Promise<
      typeof import('@pages/settings/currencies/create')
    >
);
